import axios from "axios";

const getBase = () => "notification"

const fetchAll = async (page, size, userID) => {
    return axios.get(getBase() + '/all?page=' + page + '&size=' + size + "&userID=" + userID)
}

const markAsSeen = async (notification, user) => {
    return axios.put(getBase() + '/mark-as-seen/' + user + "/" + notification)
}

const Notification = {
    fetchAll,
    markAsSeen
}
export default Notification